import { render } from "./HelloWorld.vue?vue&type=template&id=1d4b99fb"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=1d4b99fb&lang=css"
script.render = render

export default script